import {useState} from "react";
import checkUserEmail from "../api/checkUserEmail";
import {emailFormatValidation} from "../helpers/emailFormatValidation";
import LoginCard from "./LoginCard";
import RegisterCard from "./RegisterCard";

const LoginForm = () => {
  const [loginFields, setLoginFields] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showRegister, setShowRegister] = useState(false);
  const [loginPassword, setLoginPassword] = useState(false);

  const handleFieldChange = (field: "email" | "password", value: string) => {
    setLoginFields((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (message) setMessage("");
  };

  const onSubmitHandler = async () => {
    const {email} = loginFields;

    if (!email) {
      setMessage("Please enter your email.");
      return;
    }

    if (!emailFormatValidation(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await checkUserEmail(email);
      if (response?.success) {
        setMessage("User found, continue login...");
        setShowRegister(false);
      }
      setLoginPassword(true);
    } catch (error) {
      if (error instanceof Error) {
        setMessage(error.message);
        if (error.message.includes("not found")) {
          setShowRegister(true);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showRegister ? (
        <div className="overlay-register login-modal-container">
          <RegisterCard email={loginFields?.email} />
        </div>
      ) : (
        <div className="overlay-login login-modal-container">
          <LoginCard
            email={loginFields.email}
            password={loginFields.password}
            setEmail={(value) => handleFieldChange("email", value)}
            setPassword={(value) => handleFieldChange("password", value)}
            onSubmitHandler={onSubmitHandler}
            loading={loading}
            message={message}
            loginPassword={loginPassword}
          />
        </div>
      )}
    </>
  );
};

export default LoginForm;
